import React from "react";
import { Avatar } from "@material-ui/core";
import { i18n } from "../../translate/i18n";

export default function TicketInfo({ contact, ticket, onClick }) {
  return <button type="button" onClick={onClick} className="tw-flex tw-min-w-0 tw-flex-1 tw-cursor-pointer tw-items-center tw-gap-3 tw-border-0 tw-bg-transparent tw-py-2 tw-text-left tw-text-inherit">
    <Avatar src={contact.profilePicUrl} alt={contact.name} className="tw-h-11 tw-w-11 tw-bg-slate-300 tw-text-slate-600">{contact.name?.charAt(0)}</Avatar>
    <span className="tw-min-w-0 tw-flex-1">
      <span className="tw-block tw-truncate tw-text-base tw-font-semibold">{contact.name}</span>
      <span className="tw-block tw-truncate tw-text-xs tw-text-slate-500 dark:tw-text-slate-300">
        {[ticket.queue?.name, ticket.user && `${i18n.t("messagesList.header.assignedTo")} ${ticket.user.name}`].filter(Boolean).join(" · ")}
      </span>
    </span>
  </button>;
}
